// Mintlify's Prompt: the description is an attribute, the prompt the body.

import { escapePanelAttribute } from "../panel-markdown"

interface TurndownLike {
	addRule: (
		key: string,
		rule: {
			filter: (node: Node) => boolean
			replacement: (content: string, node: Node) => string
		},
	) => void
	turndown: (input: string) => string
}

const isPrompt = (node: Node): boolean =>
	node.nodeName === "DIV" &&
	(node as HTMLElement).getAttribute("data-type") === "prompt"

export function promptActionsAttribute(actions: string | null): string {
	const list = (actions ?? "")
		.split(/[\s,]+/)
		.filter((item) => item === "copy" || item === "cursor")
	const unique = [...new Set(list)]
	// Copy alone is Mintlify's default, so it is left unsaid.
	if (unique.length === 0 || (unique.length === 1 && unique[0] === "copy")) {
		return ""
	}
	return `actions={[${unique.map((item) => `"${item}"`).join(", ")}]}`
}

export function addPromptMarkdownRules(turndown: TurndownLike): void {
	turndown.addRule("prompt", {
		filter: isPrompt,
		replacement: (_content, node) => {
			const element = node as HTMLElement
			const descriptionHtml =
				element.querySelector("[data-prompt-description]")?.innerHTML ?? ""
			const description = descriptionHtml
				? turndown
						.turndown(descriptionHtml)
						.replace(/\s*\n\s*/g, " ")
						.trim()
				: ""
			const text = (
				element.querySelector("[data-prompt-text]")?.textContent ?? ""
			).replace(/\n+$/, "")
			const icon = element.getAttribute("data-icon")
			const attributes = [
				`description="${escapePanelAttribute(description)}"`,
				icon ? `icon="${escapePanelAttribute(icon)}"` : "",
				promptActionsAttribute(element.getAttribute("data-actions")),
			]
				.filter(Boolean)
				.join(" ")
			return `\n\n<Prompt ${attributes}>\n${text}\n</Prompt>\n\n`
		},
	})
}
